// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueRouter from 'vue-router'
import Vue2Filters from 'vue2-filters'
import BootstrapVue from 'bootstrap-vue'

import 'assets/scss/style.scss'

Vue.use(BootstrapVue)
Vue.use(VueRouter)
Vue.use(Vue2Filters)

// FontAwesome config
import fontawesome from '@fortawesome/fontawesome'
import { faExclamationTriangle, faRedo, faTimes, faTint, faTrash, faSave,
  faCog, faSync, faClone, faCrosshairs, faBan, faSpinner, faBomb, faPlus } from '@fortawesome/fontawesome-free-solid'
import { faChevronDoubleUp, faPen, faArrowToTop, faArrowToBottom, faLevelDown } from '@fortawesome/fontawesome-pro-solid'
import { faPlus as faPlusR, faTimes as faTimesR, faArrowRight as faArrowRightR } from '@fortawesome/fontawesome-pro-regular'

fontawesome.library.add(faExclamationTriangle, faRedo, faTimes, faTint, faTrash, faSave, faCog, faSync, faClone, faCrosshairs, faBan, faSpinner, faBomb, faPlus)
fontawesome.library.add(faChevronDoubleUp, faPen, faArrowToTop, faArrowToBottom, faLevelDown)
fontawesome.library.add(faPlusR, faTimesR, faArrowRightR)
fontawesome.dom.i2svg()

// Custom SVG icons
import './external/svgxuse.js'

// App config
import App from './App'
import Home from './components/Home'
import Tracker from './components/Tracker'
import Roller from './components/roller/Roller'
import Modifiers from './components/modifiers/Modifiers'

const routes = [
  { path: '/home', component: Home, alias: '/' },
  { path: '/modifiers', component: Modifiers },
  { path: '/tracker', component: Tracker },
  { path: '/roller', component: Roller }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.environment === 'development' ? '/' : '/shadowtools/',
  routes
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js